import { render, staticRenderFns } from "./OrderList.vue?vue&type=template&id=238c7f52&scoped=true&"
import script from "./OrderList.vue?vue&type=script&lang=js&"
export * from "./OrderList.vue?vue&type=script&lang=js&"
import style0 from "./OrderList.vue?vue&type=style&index=0&id=238c7f52&prod&lang=scss&scoped=true&"
import style1 from "./OrderList.vue?vue&type=style&index=1&id=238c7f52&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238c7f52",
  null
  
)

export default component.exports